import * as Yup from 'yup';
import { mixed, object, string } from 'yup';

import { AUSTRALIAN_STATES, AustralianState } from 'src/constants';

const errorRego = 'Please enter a valid registration plate';
const errorState = 'Please select a state';

const checkRegoLength: Yup.TestFunction = (value: string | undefined) => {
  return !!value && value.replaceAll(' ', '').length <= 7;
};

export const RegoValidation = object({
  rego: string().required(errorRego).test('character-length', errorRego, checkRegoLength),
  state: mixed().oneOf(AUSTRALIAN_STATES, errorState).required(errorState),
});

export interface TradeInSearchResult {
  cylinders: string;
  description: string;
  // these params from the API are in camelcase
  /* eslint-disable camelcase */
  engine_size: number;
  fuel_type: string;
  make_name: string;
  model_name: string;
  model_year: number;
  /* eslint-enable camelcase */
  rego: string;
  state: AustralianState;
  transmission: string;
  variant: string;
  vin: string;
}
